export class HspOpportunitySearchModel implements IHspOpportunitySearchModel {
  companyId?: string | undefined;
  dateCreated?: string | undefined;
  hspOpportunityStudentStatus?: string | undefined;
  hspOpportunityStudentStatusIndex?: number | undefined;
  hspOpportunityStudentStatusLastUpdated?: Date | undefined;
  hspOpportunityId?: string | undefined;
  seasonNumber?: number | undefined;
  seasonYear?: number | undefined;
  seasonIndex?: number | undefined;

  constructor(data?: IHspOpportunitySearchModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.companyId = Data["companyId"];
      this.dateCreated = Data["dateCreated"];
      this.hspOpportunityStudentStatus = Data["hspOpportunityStudentStatus"];
      this.hspOpportunityStudentStatusIndex = Data["hspOpportunityStudentStatusIndex"];
      this.hspOpportunityStudentStatusLastUpdated = Data["hspOpportunityStudentStatusLastUpdated"] ? new Date(Data["hspOpportunityStudentStatusLastUpdated"].toString()) : <any>undefined;
      this.hspOpportunityId = Data["hspOpportunityId"];
      this.seasonNumber = Data["seasonNumber"];
      this.seasonYear = Data["seasonYear"];
      this.seasonIndex = Data["seasonIndex"];
    }
  }

  static fromJS(data: any): HspOpportunitySearchModel {
    data = typeof data === 'object' ? data : {};
    let result = new HspOpportunitySearchModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["companyId"] = this.companyId;
    data["dateCreated"] = this.dateCreated;
    data["hspOpportunityStudentStatus"] = this.hspOpportunityStudentStatus;
    data["hspOpportunityStudentStatusIndex"] = this.hspOpportunityStudentStatusIndex;
    data["hspOpportunityStudentStatusLastUpdated"] = this.hspOpportunityStudentStatusLastUpdated ? this.hspOpportunityStudentStatusLastUpdated.toISOString() : <any>undefined;
    data["hspOpportunityId"] = this.hspOpportunityId;
    data["seasonNumber"] = this.seasonNumber;
    data["seasonYear"] = this.seasonYear;
    data["seasonIndex"] = this.seasonIndex;
    return data;
  }
}

export interface IHspOpportunitySearchModel {
  companyId?: string | undefined;
  dateCreated?: string | undefined;
  hspOpportunityStudentStatus?: string | undefined;
  hspOpportunityStudentStatusIndex?: number | undefined;
  hspOpportunityStudentStatusLastUpdated?: Date | undefined;
  hspOpportunityId?: string | undefined;
  seasonNumber?: number | undefined;
  seasonYear?: number | undefined;
  seasonIndex?: number | undefined;
}